import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { SubscribtionService } from './../../../Services/subscribtion.service';
import { MainService } from 'src/app/Services/service.service';
import { SubscriptionInformationComponent as SubscriptionInformationComponentCore} from './../../../SubscriptionInformation/subscriptionInformation.component';
import { Component } from '@angular/core';


@Component({
    selector: 'app-subscription-information',
    templateUrl: './subscription-information.component.html',
    styleUrls: ['./subscription-information.component.scss']
})
export class SubscriptionInformationComponent extends SubscriptionInformationComponentCore{

    constructor(public mainService: MainService, subscribtionService: SubscribtionService, router: Router, dialog: MatDialog) {
        super(mainService, subscribtionService, router, dialog);
        mainService.pageName = "Subscription Information";
    }

}
